export default {
  APP_CLIENT_CHANGE: "APP_CLIENT_CHANGE",
  SET_UI_NOTIFICATIONS: "SET_UI_NOTIFICATIONS",
  DISMISS_UI_GENERATED_NOTIFICATIONS: "DISMISS_UI_GENERATED_NOTIFICATIONS",
};
